import React from 'react'
import { Base, LazyLoadBlock } from '../../components'
import { StructuredData, PAGES } from '../../utils'
import { BillboardWithImage } from '../../shared/components/v2/BillboardWithImage/BillboardWithImage'
import { BillboardWithContentCards } from '../../shared/components/v2/BillboardWithContentCards/BillboardWithContentCards'
import {
  contactUsBillboardProps,
  contactUsFeaturesBillboardWithContentCardsProps,
} from '../../data/pages/contact-us.data'

const ContactUs = (): JSX.Element => {
  const CONTACT_US = PAGES.CONTACT_US
  return (
    <Base
      headKey={CONTACT_US.HEAD_KEY}
      title={CONTACT_US.TITLE}
      metaDescription={CONTACT_US.DESCRIPTION}
      breadcrumbs={CONTACT_US.BREADCRUMBS}
      customFooterBody={
        '¹Support hours: Monday to Friday, 8AM to 9PM ET, and Saturday to Sunday, 9AM to 6PM ET (excluding December 25th).\n\n'
      }
    >
      <StructuredData schemaTypes={['ContactPage', 'ContactPoint', 'Organization']} />
      <BillboardWithImage {...contactUsBillboardProps} />

      <LazyLoadBlock>
        <BillboardWithContentCards {...contactUsFeaturesBillboardWithContentCardsProps} />
      </LazyLoadBlock>
    </Base>
  )
}

export default ContactUs
